<template>
  <div class="profile-layout">
    <div class="customer-profile">
      <customer-profile
      @showInvalidFormError="showInvalidFormError"/>
    </div>
    <error-message :errorText="errorMessage" @close="errorMessage = ''" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomerProfile from '@/views/customer-profile/CustomerProfile.vue';
import {
  LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS,
  LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS, LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS,
  LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS,
  LOAD_CUSTOMER_PROFILE_DETAILS,
} from '@/store/user/actionTypes';
import { LOAD_CYBERSECURITY_KNOWHOW_OPTIONS, LOAD_AMOUNT_OF_EMPLOYEES } from '@/store/registration/actionTypes';
import ErrorMessage from '@/components/common/ErrorMessage.vue';

export default {
  name: 'Profile',
  components: {
    CustomerProfile,
    ErrorMessage,
  },
  data() {
    return {
      tab: this.$t('user.customer.edit.profile.details'),
      errorMessage: '',
    };
  },
  async created() {
    await this.$store.dispatch(LOAD_CUSTOMER_PROFILE_DETAILS);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS);
    await this.$store.dispatch(LOAD_AMOUNT_OF_EMPLOYEES);
    await this.$store.dispatch(LOAD_CYBERSECURITY_KNOWHOW_OPTIONS);
    await this.$store.dispatch(LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS);
  },
  computed: {
    ...mapGetters(['customerProfileDetails', 'companyCustomerProfileDetails']),
  },
  methods: {
    showInvalidFormError(e) {
      this.errorMessage = e.message;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.profile-layout {
  display: flex;
  flex-direction: column;
  margin-left: 4%;
  margin-top: 3%;
}

.customer-profile {
  flex: 1;
  margin-right: 4%;
}

.tab-button {
  color: var(--text-tertiary);
  font-family: $font-family-regular;
  font-size: $font-size-base;
  line-height: $font-size-base;
  text-align: center;
}
</style>
